<template>
  <div class="container">
    <h4 class="title is-4">Reports</h4>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div>
            <h4 class="title is-4">All Evaluations</h4>
            <h6 class="title is-6" v-if="allEvaluations.length">
              Count: {{ allEvaluations.length }}
            </h6>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button class="button" @click="exportData(allEvaluationsExportUrl)">
            Export
          </button>
        </div>
        <div class="level-item" v-if="allEvaluations.length">
          <button class="button" v-if="alllistVisible" @click="alllistVisible = !alllistVisible">
            Hide List of Submissions
          </button>
          <button class="button" v-if="!alllistVisible" @click="alllistVisible = !alllistVisible">
            Show List of Submissions
          </button>
        </div>
      </div>
    </div>
    <table class="table" v-if="allEvaluations.length && alllistVisible">
      <thead>
        <tr>
          <th>Evaluator Name</th>
          <th>Submission Name</th>
          <th>Submission Organization</th>
          <th>Last Edited</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="evaluation in allEvaluations" :key="evaluation.name">
          <td>
            <router-link
              :to="{
                name: 'EvaluatorDetail',
                params: { evaluatorId: evaluation.Evaluator_ID },
              }"
              target="_blank"
              >{{ evaluation.Evaluator_Name }}
            </router-link>
          </td>
          <td>
            <router-link
              :to="{
                name: 'StaffApplicationReviewDetail',
                params: { applicationId: evaluation.Submission_ID },
              }"
              target="_blank"
              >{{ evaluation.Submission_Name }}
            </router-link>
          </td>
          <td>
            <router-link
              :to="{
                name: 'StaffApplicationReviewDetail',
                params: { applicationId: evaluation.Submission_ID },
              }"
              target="_blank"
              >{{ evaluation.Submitter_Name }}
            </router-link>
          </td>
          <td>
            {{ evaluation.Last_Edited }}
          </td>
        </tr>
      </tbody>
    </table>

    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div>
            <h4 class="title is-4">Ten most recent completed evaluations</h4>
            <h6 class="title is-6" v-if="tenRecent.length">Count: {{ tenRecent.length }}</h6>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button class="button" @click="exportData(tenRecentExportUrl)">
            Export
          </button>
        </div>
        <div class="level-item" v-if="tenRecent.length">
          <button class="button" v-if="tenlistVisible" @click="tenlistVisible = !tenlistVisible">
            Hide List of Submissions
          </button>
          <button class="button" v-if="!tenlistVisible" @click="tenlistVisible = !tenlistVisible">
            Show List of Submissions
          </button>
        </div>
      </div>
    </div>
    <table class="table" v-if="tenRecent.length && tenlistVisible">
      <thead>
        <tr>
          <th>Evaluator Name</th>
          <th>Submission Name</th>
          <th>Submission Organization</th>
          <th>Last Edited</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="evaluation in tenRecent" :key="evaluation.name">
          <td>
            <router-link
              :to="{
                name: 'EvaluatorDetail',
                params: { evaluatorId: evaluation.Evaluator_ID },
              }"
              target="_blank"
              >{{ evaluation.Evaluator_Name }}
            </router-link>
          </td>
          <td>
            <router-link
              :to="{
                name: 'StaffApplicationReviewDetail',
                params: { applicationId: evaluation.Submission_ID },
              }"
              target="_blank"
              >{{ evaluation.Submission_Name }}
            </router-link>
          </td>
          <td>
            <router-link
              :to="{
                name: 'StaffApplicationReviewDetail',
                params: { applicationId: evaluation.Submission_ID },
              }"
              target="_blank"
              >{{ evaluation.Submitter_Name }}
            </router-link>
          </td>
          <td>
            {{ evaluation.Last_Edited }}
          </td>
        </tr>
      </tbody>
    </table>

    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div>
            <h4 class="title is-4">All Follow-Ups</h4>
            <h6 class="title is-6" v-if="followups.length">Count: {{ followups.length }}</h6>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button class="button" @click="exportData(followupsExportUrl)">
            Export
          </button>
        </div>
        <div class="level-item" v-if="followups.length">
          <button class="button" v-if="followlistVisible" @click="followlistVisible = !followlistVisible">
            Hide List of Follow-Ups
          </button>
          <button class="button" v-if="!followlistVisible" @click="followlistVisible = !followlistVisible">
            Show List of Follow-Ups
          </button>
        </div>
      </div>
    </div>
    <table class="table" v-if="followups.length && followlistVisible">
      <thead>
        <tr>
          <th>Evaluator Name</th>
          <th>Submission Name</th>
          <th>Org Submitted To</th>
          <th>Type</th>
          <th>Follow Up Request</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="evaluation in followups" :key="evaluation.name">
          <td>
            <router-link
              :to="{
                name: 'EvaluatorDetail',
                params: { evaluatorId: evaluation.Evaluator_ID },
              }"
              target="_blank"
              >{{ evaluation.Evaluator_Name }}
            </router-link>
          </td>
          <td>
            <router-link
              :to="{
                name: 'StaffApplicationReviewDetail',
                params: { applicationId: evaluation.Submission_ID },
              }"
              target="_blank"
              >{{ evaluation.Submission_Name }}
            </router-link>
          </td>
          <td>
            <router-link
              :to="{
                name: 'StaffApplicationReviewDetail',
                params: { applicationId: evaluation.Submission_ID },
              }"
              target="_blank"
              >{{ evaluation.Organization_Submitted_To }}
            </router-link>
          </td>
          <td>{{ evaluation.Commitment_Type }}</td>
          <td>{{ evaluation.Description }}</td>
        </tr>
      </tbody>
    </table>

    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div>
            <h4 class="title is-4">All Submissions sorted by number of completed evaluations</h4>
            <h6 class="title is-6" v-if="completed.length">Count: {{ completed.length }}</h6>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button class="button" @click="exportData(completedExportUrl)">
            Export
          </button>
        </div>
        <div class="level-item" v-if="completed.length">
          <button class="button" v-if="completedlistVisible" @click="completedlistVisible = !completedlistVisible">
            Hide List of Completed
          </button>
          <button class="button" v-if="!completedlistVisible" @click="completedlistVisible = !completedlistVisible">
            Show List of Completed
          </button>
        </div>
      </div>
    </div>
    <table class="table" v-if="completed.length && completedlistVisible">
      <thead>
        <tr>
          <th>Organization</th>
          <th>Submission Name</th>
          <th># of Completed Evals</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="evaluation in completed" :key="evaluation.name">
          <td>
            <router-link
              :to="{
                name: 'StaffApplicationReviewDetail',
                params: { applicationId: evaluation.ID },
              }"
              target="_blank"
              >{{ evaluation.Organization }}</router-link
            >
          </td>
          <td>
            <router-link
              :to="{
                name: 'StaffApplicationReviewDetail',
                params: { applicationId: evaluation.ID },
              }"
              target="_blank"
              >{{ evaluation.Submission_Name }}</router-link
            >
          </td>
          <td>{{ evaluation['#_of_Completed_Evaluations'] }}</td>
        </tr>
      </tbody>
    </table>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div>
            <h4 class="title is-4">All Submissions with number of completed evaluations equaling zero</h4>
            <h6 class="title is-6" v-if="zero.length">Count: {{ zero.length }}</h6>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button class="button" @click="exportData(zeroExportUrl)">
            Export
          </button>
        </div>
        <div class="level-item" v-if="zero.length">
          <button class="button" v-if="zerolistVisible" @click="zerolistVisible = !zerolistVisible">
            Hide List of Zero Completed
          </button>
          <button class="button" v-if="!zerolistVisible" @click="zerolistVisible = !zerolistVisible">
            Show List of Zero Completed
          </button>
        </div>
      </div>
    </div>
    <table class="table" v-if="zero.length && zerolistVisible">
      <thead>
        <tr>
          <th>Organization</th>
          <th>Submission Name</th>
          <th>Project Info</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="evaluation in zero" :key="evaluation.name">
          <td>
            <router-link
              :to="{
                name: 'StaffApplicationReviewDetail',
                params: { applicationId: evaluation.ID },
              }"
              target="_blank"
              >{{ evaluation.Organization }}
            </router-link>
          </td>
          <td>
            <router-link
              :to="{
                name: 'StaffApplicationReviewDetail',
                params: { applicationId: evaluation.ID },
              }"
              target="_blank"
              >{{ evaluation.Submission_Name }}
            </router-link>
          </td>
          <td>{{ evaluation.Project_Name }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import store from '@/vuex/store'
import moment from 'moment'

import Report from '@/services/reports'
import ReportLoader from '@/components/reports/SubmissionReportLoader'

export default {
  components: {
    ReportLoader,
  },
  data() {
    return {
      alllistVisible: false,
      tenlistVisible: false,
      followlistVisible: false,
      completedlistVisible: false,
      zerolistVisible: false,
      allEvaluations: {
        type: Array,
        default: () => [],
      },
      tenRecent: {
        type: Array,
        default: () => [],
      },
      followups: {
        type: Array,
        default: () => [],
      },
      completed: {
        type: Array,
        default: () => [],
      },
      zero: {
        type: Array,
        default: () => [],
      },
      allEvaluationsExportUrl:"evaluations/export-feedback/",
      tenRecentExportUrl: "evaluations/export-recent-evaluations/",
      followupsExportUrl: "evaluations/export-commitments/",
      completedExportUrl: "applications/export/",
      zeroExportUrl: "applications/exportZero/",
      reportDataLoaded: false,
    }
  },
  created() {
    
    Report.api
      .retrieveExportData(this.allEvaluationsExportUrl)
      .then(data => {
        this.allEvaluations = data
        this.reportDataLoaded = true
        //console.log("this.allEvaluations")
        //console.log(this.allEvaluations)
      })
      .catch(err => {
        this.$Alert.alert({
          type: 'error',
          message: `Error loading reports`,
          timeout: 6000,
        })
      })
    Report.api
      .retrieveExportData(this.tenRecentExportUrl)
      .then(data => {
        this.tenRecent = data
        this.reportDataLoaded = true
        //console.log("this.tenRecent")
        //console.log(this.tenRecent)
      })
      .catch(err => {
        this.$Alert.alert({
          type: 'error',
          message: `Error loading reports`,
          timeout: 6000,
        })
      })
    Report.api
      .retrieveExportData(this.followupsExportUrl)
      .then(data => {
        this.followups = data
        this.reportDataLoaded = true
        //console.log("this.followups")
        //console.log(this.followups)
      })
      .catch(err => {
        this.$Alert.alert({
          type: 'error',
          message: `Error loading reports`,
          timeout: 6000,
        })
      })
    Report.api
      .retrieveExportData(this.completedExportUrl)
      .then(data => {
        this.completed = data
        this.reportDataLoaded = true
        //console.log("this.completed")
        //console.log(this.completed)
      })
      .catch(err => {
        this.$Alert.alert({
          type: 'error',
          message: `Error loading reports`,
          timeout: 6000,
        })
      })
    Report.api
      .retrieveExportData(this.zeroExportUrl)
      .then(data => {
        this.zero = data
        this.reportDataLoaded = true
        //console.log("this.zero")
        //console.log(this.zero)
      })
      .catch(err => {
        this.$Alert.alert({
          type: 'error',
          message: `Error loading reports`,
          timeout: 6000,
        })
      })
  },
  methods: {
    exportData(exportURL) {
      //console.log("exportData-submissionloader")
      Report.api
        .retrieveExport(exportURL)
        .then(response => {
          //console.log("response-submissionloader")
          this.$Alert.alert({
            type: 'success',
            message: `Export Successful`,
            timeout: 6000,
          })
        })
        .catch(err => {
          //console.log("catch")
          this.$Alert.alert({
            type: 'error',
            message: `Export Failed`,
            timeout: 6000,
          })
        })
    },
    exportData2(exportURL) {
      //console.log("exportURL")
      const exportPromise = store.getters.apiClient.get(exportURL)
      exportPromise.then(response => {
        //console.log("exportData-response")
        //console.log(response)
        this.forceFileDownload(response)
        this.$Alert.alert({
          type: 'success',
          message: `Export Successful`,
          timeout: 6000,
        })
      })
    },
    forceFileDownload(response) {
      //console.log("forceFileDownload")
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const disposition = response.headers['content-disposition']

      // I shamelessly stole this from stack overflow. I should clean this up
      var filename = 'file.csv'
      if (disposition && disposition.indexOf('attachment') !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        var matches = filenameRegex.exec(disposition)
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '')
        }
      }
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${moment().format('M-D-YY, h.mm.ss a')} - ${filename}`)
      document.body.appendChild(link)
      link.click()
    },
  },
}
</script>
<style scoped></style>
